import { useEffect, useRef, useState } from 'react';
import { registerSW } from 'virtual:pwa-register';

/**
 * Registers the service worker and reports when a new version is waiting.
 *
 * The update is never applied on its own. A trainee halfway through logging a
 * central line does not want the page to reload under their thumb, and an
 * auto-reload mid-entry would lose whatever they had typed — which is exactly
 * the kind of small, deniable data loss this project cannot afford.
 */
export function useServiceWorker(): { updateReady: boolean; applyUpdate: () => void } {
  const [updateReady, setUpdateReady] = useState(false);
  const update = useRef<((reload?: boolean) => Promise<void>) | null>(null);

  useEffect(() => {
    update.current = registerSW({
      immediate: true,
      onNeedRefresh: () => setUpdateReady(true),
    });
  }, []);

  return {
    updateReady,
    applyUpdate: () => {
      setUpdateReady(false);
      void update.current?.(true);
    },
  };
}
